(function () {
  'use strict';
  if (window.LivvewellLullaBearHandoff && window.LivvewellLullaBearHandoff.__loaded) return;

  var API = window.LivvewellLullaBearHandoff || {};
  API.__loaded = true;
  window.LivvewellLullaBearHandoff = API;

  function qs(root, selector){ return root ? root.querySelector(selector) : null; }
  function qsa(root, selector){ return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : []; }

  function cleanMoney(value){
    var temp = document.createElement('div');
    temp.innerHTML = value || '';
    return (temp.textContent || temp.innerText || '').trim();
  }

  function track(name, detail){
    var payload = detail || {};
    document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:payload}));
    if(window.dataLayer && Array.isArray(window.dataLayer)){
      var dl={event:name};
      Object.keys(payload).forEach(function(key){dl[key]=payload[key];});
      window.dataLayer.push(dl);
    }
    if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish==='function'){
      try{window.Shopify.analytics.publish(name,payload);}catch(e){}
    }
  }

  function variantData(root){
    var node=qs(root,'[data-lw-lbh-variant]');
    if(!node) return null;
    if(node.tagName==='SELECT'){
      var option=node.options[node.selectedIndex];
      if(!option) return null;
      return {id:option.value,price:cleanMoney(option.dataset.price||''),compare:cleanMoney(option.dataset.compare||''),available:option.dataset.available==='true',image:option.dataset.image||''};
    }
    return {id:node.value,price:cleanMoney(node.dataset.price||''),compare:cleanMoney(node.dataset.compare||''),available:node.dataset.available==='true',image:node.dataset.image||''};
  }

  function updateRoot(root){
    var v=variantData(root); if(!v) return;
    qsa(root,'[data-lw-lbh-price]').forEach(function(n){n.textContent=v.price;});
    qsa(root,'[data-lw-lbh-compare]').forEach(function(n){n.textContent=v.compare;n.hidden=!v.compare;});
    var img=qs(root,'[data-lw-lbh-image]');
    if(img && v.image){img.src=v.image;img.removeAttribute('srcset');}
    var btn=qs(root,'[data-lw-lbh-atc]');
    if(btn) btn.disabled=!v.available;
  }

  function syncVariant(sourceRoot){
    var v=variantData(sourceRoot), productId=sourceRoot.dataset.productId||'';
    if(!v || !v.id || !productId) return;

    qsa(document,'[data-lw-lbh-root][data-product-id="'+productId+'"]').forEach(function(root){
      var node=qs(root,'[data-lw-lbh-variant]');
      if(node && node.tagName==='SELECT'){
        var option=qsa(node,'option').find(function(o){return String(o.value)===String(v.id) && !o.disabled;});
        if(option) node.value=v.id;
      }else if(node){node.value=v.id;}
      updateRoot(root);
    });

    track('lullabear_handoff_variant_selected',{product_id:productId,variant_id:v.id});
  }

  function addToCart(root,button){
    var v=variantData(root);
    if(!v || !v.id || !v.available || button.disabled) return;

    var label=qs(root,'[data-lw-lbh-atc-label]');
    var error=qs(root,'[data-lw-lbh-error]');
    var original=label?label.textContent:'Add to cart';
    var placement=button.dataset.lwLbhPlacement||'unknown';

    track('lullabear_handoff_cta_click',{placement:placement,product_id:root.dataset.productId||'',variant_id:v.id});
    button.disabled=true;
    if(label) label.textContent='Adding...';
    if(error){error.hidden=true;error.textContent='';}

    var shopRoot=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';

    window.fetch(shopRoot+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(v.id),quantity:1,properties:{'_livvewell_lullabear_handoff_page':'true','_sales_page_cta':placement}}]})
    })
    .then(function(r){if(!r.ok) throw new Error('Unable to add LullaBear to cart.');return r.json();})
    .then(function(){
      track('lullabear_handoff_add_to_cart',{placement:placement,product_id:root.dataset.productId||'',variant_id:v.id});
      root.dispatchEvent(new CustomEvent('lw:lullabear:added',{bubbles:true,detail:{placement:placement,product_id:root.dataset.productId||'',variant_id:v.id}}));
      if(label) label.textContent='Added';
      window.setTimeout(function(){
        button.disabled=false;
        if(label) label.textContent=original;
        if(window.LivvewellCartDrawer && typeof window.LivvewellCartDrawer.open==='function') window.LivvewellCartDrawer.open();
      },180);
    })
    .catch(function(err){
      button.disabled=false;if(label) label.textContent=original;
      if(error){error.textContent=err&&err.message?err.message:'Unable to add LullaBear. Please try again.';error.hidden=false;}
      track('lullabear_handoff_add_to_cart_error',{placement:placement,product_id:root.dataset.productId||''});
    });
  }

  function initProductRoot(root){
    if(!root || root.dataset.lwLbhReady==='true') return;
    root.dataset.lwLbhReady='true';
    var variant=qs(root,'[data-lw-lbh-variant]');
    var button=qs(root,'[data-lw-lbh-atc]');
    if(variant && variant.tagName==='SELECT') variant.addEventListener('change',function(){syncVariant(root);});
    if(button) button.addEventListener('click',function(){addToCart(root,button);});
    updateRoot(root);
  }

  function initCareCircle(circle){
    if(!circle || circle.dataset.lwLbhCircleReady==='true') return;
    circle.dataset.lwLbhCircleReady='true';
    var tabs=qsa(circle,'[data-lw-lbh-circle-tab]');
    var panels=qsa(circle,'[data-lw-lbh-circle-panel]');

    function select(id){
      tabs.forEach(function(tab){
        var active=tab.dataset.lwLbhCircleTab===id;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active?'true':'false');
      });
      panels.forEach(function(panel){
        var active=panel.dataset.lwLbhCirclePanel===id;
        panel.classList.toggle('is-active',active);
        panel.hidden=!active;
      });
      track('lullabear_handoff_caregiver_selected',{caregiver_block:id});
    }

    tabs.forEach(function(tab){tab.addEventListener('click',function(){select(tab.dataset.lwLbhCircleTab);});});
  }

  function initSticky(){
    var sticky=qs(document,'[data-lw-lbh-sticky]');
    var hero=qs(document,'[data-lw-lbh-hero]');
    var finalSection=qs(document,'[data-lw-lbh-final]');
    if(!sticky || !hero || sticky.dataset.lwLbhStickyReady==='true') return;
    sticky.dataset.lwLbhStickyReady='true';

    var heroVisible=true, finalVisible=false;
    function apply(){
      var visible=!heroVisible&&!finalVisible;
      var wasVisible=sticky.classList.contains('is-visible');
      sticky.classList.toggle('is-visible',visible);
      sticky.setAttribute('aria-hidden',visible?'false':'true');
      if(visible&&!wasVisible) track('lullabear_handoff_sticky_shown',{});
    }

    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.target===hero) heroVisible=entry.isIntersecting;
          if(finalSection && entry.target===finalSection) finalVisible=entry.isIntersecting;
        });
        apply();
      },{threshold:.08});
      observer.observe(hero);if(finalSection) observer.observe(finalSection);
    }
  }

  function initTracking(){
    if(!('IntersectionObserver' in window)) return;
    var sections=qsa(document,'[data-lw-lbh-track]').filter(function(s){return s.dataset.lwLbhTracked!=='true';});
    if(!sections.length) return;
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting || entry.intersectionRatio<.28) return;
        var s=entry.target;s.dataset.lwLbhTracked='true';
        track('lullabear_handoff_section_view',{section:s.dataset.lwLbhTrack||''});
        observer.unobserve(s);
      });
    },{threshold:[.28]});
    sections.forEach(function(s){observer.observe(s);});
  }

  function boot(scope){
    qsa(scope||document,'[data-lw-lbh-root]').forEach(initProductRoot);
    qsa(scope||document,'[data-lw-lbh-circle]').forEach(initCareCircle);
    initSticky();initTracking();
  }

  function initialBoot(){boot(document);track('lullabear_handoff_page_view',{path:window.location.pathname});}

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialBoot);
  else initialBoot();

  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
  API.init=boot;API.track=track;
})();